import { render, staticRenderFns } from "./courier-list.vue?vue&type=template&id=808dba46&scoped=true"
import script from "./courier-list.vue?vue&type=script&lang=js"
export * from "./courier-list.vue?vue&type=script&lang=js"
import style0 from "./courier-list.vue?vue&type=style&index=0&id=808dba46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "808dba46",
  null
  
)

export default component.exports